var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-single-side"},[(_vm.id)?_c('PostTopic',{attrs:{"type":"tool","id":~~_vm.id}}):_vm._e(),_c('PostDirectory',{attrs:{"id":"directory"}}),(_vm.showSideCollection)?_c('PostCollection',{attrs:{"store":_vm.collection_data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }